<div class="outer-container">

  <!-- Loading overlay -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="loading-overlay-spinner">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </div>

  <!-- Main container -->
  <div class="container" [class.taken]="isSelected">

    <h2>{{equipmentName}}</h2>
    <h3>{{serial}}</h3>
    <!--<h4><mat-icon color="primary">chat</mat-icon> {{name}}</h4>-->
    <h4><mat-icon color="primary">person</mat-icon> {{requesterName}}</h4>
    <h4><mat-icon color="primary">access_time</mat-icon> {{date.toLocaleTimeString()}} - {{date.toLocaleDateString()}}</h4>
    <div class="chips">
      <span *ngIf="status == getMaintenanceStatuses().QUEUE" class="queue">{{ 'Waiting' | translate }}</span>
      <span *ngIf="status == getMaintenanceStatuses().TAKEN && isTakenByMe()" class="taken" [class.by-me]="isTakenByMe()">{{ 'Taken by you' | translate }}</span>
      <span *ngIf="status == getMaintenanceStatuses().TAKEN && !isTakenByMe()" class="taken" [class.by-other]="!isTakenByMe()">{{ 'Taken by another operator' | translate }}</span>
      <span *ngIf="status == getMaintenanceStatuses().PLANNED" class="planned">{{ 'Planned' | translate }}</span>
    </div>

  </div>
</div>
